<template>
  <div :class="['more-topics', isMobile ? '' : 'more-topics-pc']">
    <div class="nav-content">
      <div class="nav-title">
        <div
          v-for="(item, index) in robotNav.subs"
          :key="index"
          class="title-wrapper"
          :class="currentTab === index ? 'active' : ''"
          @click="onChangeTab(index, item)"
        >
          <div class="title-name">{{ item.tit }}</div>
        </div>
      </div>
      <div class="nav-list-wrapper">
        <div
          v-for="(item, index) in robotNav.subs"
          :key="index"
          class="nav-list"
          v-show="currentTab === index"
        >
          <div class="nav-list-content">
            <div
              v-for="(sub, subIndex) in getPageData(item)"
              :key="subIndex"
              class="nav-item nav-link"
              @click="
                onClick(sub, {
                  robot_nav_event_type: 3,
                  robot_nav_first_menu_id: 0,
                  robot_nav_first_menu_name: item.tit,
                  robot_nav_second_menu_id: sub.id,
                  robot_nav_second_menu_name: sub.name || sub.question || '',
                })
              "
            >
              <div class="nav-item-text">{{ sub.name || sub.question || '' }}</div>
              <img class="icon-arrow-right" src="../assets/arrow.svg"/>
            </div>
          </div>
          <div
            v-if="item.showChange"
            class="nav-change"
            @click="onChange(item)"
          >
            <div class="nav-change-box">
              <img class="batch-head-icon icon-primay" src="../assets/changeBatch.svg"/>
              换一批
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
/**
 * @component 机器人导航 - 多主题型
 */
export default {
  mixins: [robotNavMixin],
};
</script>

<style lang="less" scoped>
.more-topics{
  .nav-content {
    border-radius: 6px;
    padding: 10px 16px 6px 16px;
    background-color: #fff;
    .nav-title {
      display: flex;
      .title-wrapper {
        flex: 1;
        display: flex;
        justify-content: center;
        cursor: pointer;
        .title-name {
          font-size: 14px;
          color: #262d3d;
          line-height: 16px;
          height: 20px;
          padding-bottom: 7px;
        }
        &.active {
          .title-name {
            color: @primary;
            border-bottom: 3px solid @primary;
          }
        }
      }
    }
    .nav-list-wrapper {
        .nav-list {
            margin-top: 6px;
            .nav-list-content {
                .nav-item {
                    width: 100%;
                    height: 36px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #262d3d;
                    font-size: 13px;
                    position: relative;
                    border-bottom: 1px solid #f3f5fa;
                    &:last-child{
                      border-bottom: none;
                    }
                    .nav-item-text {
                        height: 36px;
                        line-height: 36px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                        white-space: nowrap;
                    }
                    .icon-arrow-right {
                      display: inline-block;
                      position: absolute;
                      right: 0;
                      display: inline-block;
                      width: 10px;
                      height: 10px;
                    }
                }
            }
            .nav-change {
                height: 30px;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .nav-change-box {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: @primary;
                    cursor: pointer;

                    .batch-head-icon {
                        height: 12px;
                        width: 12px;
                        margin-right: 4px;
                    }
                }
            }
            &:first-child {
                display: block;
            }
        }
    }
  }
}
.more-topics-pc {
  width: 336px;
  .nav-content {
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 #e1e6f0;
    margin-top: 2px;
    background-color: #fff;
  }
}
.title-wrapper {
  // tab选中的样式
  &.active {
    color: #262d3d;
    border-bottom: none;
  }
}
</style>
